import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import { showModal, showNestedModal } from "../../../features/modal/modalSlice"
import { devamliAracDelete } from "../../../features/joblist/jobListSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: auto;
        height: auto;
        padding: 50px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        p{
            font-family: Outfit;
            font-size: 24px;
            font-weight: 500;
            line-height: 25px;
        }

        .btns{
            display: flex;
            align-items: center;
            margin-top: 25px;
            button{
                margin-right: 10px;
            }
        }
    }

`
    
const DevamliAracDeleteModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    const { selectedDevamliArac } = useSelector((state) => state.jobList)


    // //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <p>Silmek İstediğinize Emin Misiniz?</p>
            <div className="btns">
                <Button width="150px" handleClick={() => {dispatch(devamliAracDelete(selectedDevamliArac?.id)); dispatch(showModal(null))}} padding="10px" background="#fff" color={"#E85446"}>Sil</Button>
                <Button width="150px" handleClick={()=> dispatch(showModal(null))} padding="10px" background="#fff" color={"#E85446"}>Vazgeç</Button>
            </div>
            
        </div>
    </Container>
  )
}

export default DevamliAracDeleteModal